import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    event.stopPropagation()
    this.panelTarget.classList.toggle("hidden")
  }

  hide(event) {
    if (this.element.contains(event.target)) return
    this.panelTarget.classList.add("hidden")
  }

  async copyLink(event) {
    event.stopPropagation()
    this.panelTarget.classList.add("hidden")
    try {
      await navigator.clipboard.writeText(event.params.url)
      window.toast("Link copied", { kind: "success" })
    } catch {
      window.toast("Couldn't copy the link", { kind: "error" })
    }
  }
}
